import React, { useEffect, useState } from "react";
import { ExportOutlined, SearchOutlined } from "@ant-design/icons";
import { useTypedSelector } from "../../store";
import { Navigate, useNavigate } from "react-router-dom";
import { Button, DatePicker, Input, Skeleton, Space, Table } from "antd";
import * as XLSX from "xlsx";
import dayjs from "dayjs";
import { ColumnsType } from "antd/es/table";
import { useDispatch } from "react-redux";
import {
  approveAllOvertimeRequest,
  getReportOvertimeRequest,
} from "../../slices/overtime";

interface DataType {
  employeeId: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  approval_name: string;
  aaproval_id: string;
  schedule_date: string;
  schedule_id: string;
  overtime_id: string;
  location_in: string;
  location_out: string;
  request_status: string;
  rejected_notes: string;
  total_overtime: string;
  overtime_start: string;
  overtime_end: string;
  location: string;
  notes: string;
  time_in: string;
  time_out: string;
}

const columns: ColumnsType<DataType> = [
  {
    title: "Employee ID",
    dataIndex: "employeeId",
    key: "employeeId",
    sorter: (a: any, b: any) =>
      (a.employeeId || "").localeCompare(b.employeeId || ""),
  },
  //   {
  //     title: "EID",
  //     dataIndex: "eid",
  //     key: "eid",
  //     sorter: (a: any, b: any) => (a.eid || "").localeCompare(b.eid || ""),
  //   },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: (a: any, b: any) => (a.name || "").localeCompare(b.name || ""),
  },
  {
    title: "Approval",
    dataIndex: "approval_name",
    key: "approval_name",
    sorter: (a: any, b: any) =>
      (a.approval_name || "").localeCompare(b.approval_name || ""),
    render: (text: any) => text || "--",
  },
  {
    title: "Schedule Date",
    dataIndex: "schedule_date",
    key: "schedule_date",
    sorter: (a: any, b: any) =>
      (a.schedule_date || "").localeCompare(b.schedule_date || ""),
  },
  {
    title: "Location In",
    dataIndex: "location_in",
    key: "location_in",
    sorter: (a: any, b: any) =>
      (a.location_in || "").localeCompare(b.location_in || ""),
  },
  {
    title: "Location Out",
    dataIndex: "location_out",
    key: "location_out",
    sorter: (a: any, b: any) => (a.location_out || 0) - (b.location_out || 0),
  },
  {
    title: "Status",
    dataIndex: "request_status",
    key: "request_status",
    sorter: (a: any, b: any) =>
      (a.request_status || "").localeCompare(b.request_status || ""),
    render: (text: any) => text || "--",
  },

  {
    title: "Total Overtime",
    dataIndex: "total_overtime",
    key: "total_overtime",
    sorter: (a: any, b: any) =>
      (a.total_overtime || "").localeCompare(b.total_overtime || ""),
    render: (text: any) => text || "--",
  },
  {
    title: "Overtime Start",
    dataIndex: "overtime_start",
    key: "overtime_start",
    sorter: (a: any, b: any) =>
      (a.overtime_start || "").localeCompare(b.overtime_start || ""),
    render: (text: any) => text || "--",
  },
  {
    title: "Overtime End",
    dataIndex: "overtime_end",
    key: "overtime_end",
    sorter: (a: any, b: any) =>
      (a.overtime_end || "").localeCompare(b.overtime_end || ""),
    render: (text: any) => text || "--",
  },
  {
    title: "Time In",
    dataIndex: "time_in",
    key: "time_in",
    sorter: (a: any, b: any) =>
      (a.time_in || "").localeCompare(b.time_in || ""),
  },
  {
    title: "Time Out",
    dataIndex: "time_out",
    key: "time_out",
    sorter: (a: any, b: any) =>
      (a.time_out || "").localeCompare(b.time_out || ""),
  },
  {
    title: "Overtime Notes",
    dataIndex: "notes",
    key: "notes",
    sorter: (a: any, b: any) => (a.notes || "").localeCompare(b.notes || ""),
    render: (text: any) => text || "--",
  },
  {
    title: "Rejected Notes",
    dataIndex: "rejected_notes",
    key: "rejected_notes",
    sorter: (a: any, b: any) =>
      (a.rejected_notes || "").localeCompare(b.rejected_notes || ""),
    render: (text: any) => text || "--",
  },
];

const Overtime: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { authData, isLogin, lists, loading } = useTypedSelector((state) => {
    return {
      authData: state.Auth.loginData,
      isLogin: state.Auth.isLogin,
      lists: state.Overtime.lists,
      loading: state.Overtime.pageIsLoading,
    };
  });
  const [searchText, setSearchText] = useState("");
  const [startDate, setStartDate] = useState<any>(dayjs().startOf("month"));
  const [endDate, setEndDate] = useState<any>(dayjs().endOf("month"));
  const [filteredData, setFilteredData] = useState(lists);

  console.log(authData, isLogin);

  useEffect(() => {
    if (!isLogin) {
      navigate("/login");
    } else {
      dispatch(
        getReportOvertimeRequest({
          stardate: startDate.format("YYYY-MM-DD"),
          enddate: endDate.format("YYYY-MM-DD"),
        }) as any
      );
    }
  }, [isLogin, dispatch, navigate, startDate, endDate]);

  useEffect(() => {
    // Perbarui filteredData setiap kali employees berubah
    if (lists.length > 0) {
      setFilteredData(lists);
    }
  }, [lists]);

  const handleApproveAll = () => {
    dispatch(approveAllOvertimeRequest() as any);
  };

  const handleSearchText = (value: string) => {
    setSearchText(value);
    const filtered = lists.filter(
      (overtime) =>
        overtime.name.toLowerCase().includes(value.toLowerCase()) ||
        overtime.employeeId.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredData(filtered);
  };
  const handleSearch = () => {
    //   setIsLoading(true);
    // Logika untuk pencarian berdasarkan tanggal
    console.log(
      "Searching from",
      startDate.format("YYYY-MM-DD"),
      "to",
      endDate.format("YYYY-MM-DD")
    );
    dispatch(
      getReportOvertimeRequest({
        stardate: startDate.format("YYYY-MM-DD"),
        enddate: endDate.format("YYYY-MM-DD"),
      }) as any
    ).then((res: any) => {
      // setIsLoading(false)
    });
  };

  const handleExportToExcel = () => {
    // Fungsi untuk eksport ke Excel
    console.log("Export to Excel");
    const worksheet = XLSX.utils.json_to_sheet(
      lists.map((item) => ({
        employeeId: item.employeeId,
        name: item.name,
        approval_name: item.approval_name || "--",
        schedule_date: item.schedule_date,
        location_in: item.location_in,
        location_out: item.location_out,
        request_status: item.request_status || "--",
        rejected_notes: item.rejected_notes || "--",
        total_overtime: item.total_overtime || "--",
        overtime_start: item.overtime_start || "--",
        overtime_end: item.overtime_end || "--",
        overtime_notes: item.notes,
        time_in: item.time_in || "--",
        time_out: item.time_out || "--",
        status: item.status,
      }))
    );

    // Buat workbook dan tambahkan worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

    // Ekspor workbook ke file Excel
    XLSX.writeFile(workbook, "overtimes.xlsx");
  };
  return (
    <div>
      <Space
        style={{
          marginBottom: 16,
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Space>
          <Input
            placeholder="Search by name or EID"
            value={searchText}
            onChange={(e) => handleSearchText(e.target.value)}
            prefix={<SearchOutlined />}
            style={{ maxWidth: 300 }}
          />
          <DatePicker
            value={startDate}
            onChange={(date) => setStartDate(date ? date : dayjs())}
            placeholder="Start Date"
          />
          <DatePicker
            value={endDate}
            onChange={(date) => setEndDate(date ? date : dayjs())}
            placeholder="End Date"
          />
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSearch}
          />
        </Space>
        <div>
          <Button
            style={{
              backgroundColor: "#00A65A",
              borderColor: "#00A65A",
              color: "#fff",
            }}
            icon={<ExportOutlined />}
            onClick={handleExportToExcel}
          >
            Export to Excel
          </Button>
          <Button
            type="primary"
            style={{ marginLeft: 20 }}
            onClick={handleApproveAll}
          >
            Approve All
          </Button>
        </div>
      </Space>
      {!loading ? (
        <Table
          columns={columns}
          dataSource={filteredData ? filteredData : lists}
          scroll={{ x: "max-content" }}
        />
      ) : (
        <Skeleton active />
      )}
    </div>
  );
};

export default Overtime;
